import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import '../../stylesheets/Margins.css';
import '../../stylesheets/ForgetPassword.css';
import projectLogo from '../../project_logo.png'
import { AuthAPI } from "../../axios";
import Cookies from "js-cookie";

const EmailVerifySchema = Yup.object().shape({
  code: Yup.string()
    .matches(/^\d{4}$/, "Invalid code")
    .required("Code is required"),
});

const EmailVerify = () => {
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    AuthAPI.verifyEmail(JSON.stringify(values))
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          Cookies.set("userId", res.data.adminObject);
          navigate("/reset-password");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getBack = () => {
    navigate('/forget-password');
  };

  return (
    <div className="forget-container">
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src={projectLogo}
          alt="Profile"
          style={{
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      </div>
      <button className="back-button" onClick={getBack}>
        <ArrowBackIosIcon />
        Back to SignIn
      </button>
      <div className="marginTop-12">
        <span className="forget-text">Check Your Email</span>
        <br />
        <span className="please-text">We sent a reset link to newtest@gmail.com</span>
        <br />
        <span className="please-text">Enter the 4 digit code mentioned in the email</span>
      </div>
      <Formik
        initialValues={{ code: '' }}
        validationSchema={EmailVerifySchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form className="forget-inputs">
            <span className="email-text">Code</span>
            <div className="forget-input">
              <Field name="code" type="text" placeholder="1234" />
            </div>
            <ErrorMessage name="code" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }}/>
            <div className="margin20">
              <button type="submit" className="forget-button">Verify</button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EmailVerify;
